/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgConference = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M17 22C10.4 22 2 13.6 2 7c0-2.8 1.1-4.5 1.2-4.6l.3-.4h5.8l1.3 6.3L6.2 13c1.3 1.8 3 3.5 4.8 4.8l4.7-4.3 6.3 1.3v5.9l-.5.3c0-.1-1.7 1-4.5 1zm-4.2-3.2c1.4.7 2.9 1.2 4.2 1.2 1.4 0 2.4-.4 3-.6v-3.1l-3.7-.7zM4.6 4c-.2.6-.6 1.6-.6 3 0 1.3.4 2.8 1.2 4.2l3.2-3.5L7.7 4z" />
      <path d="M18 10h-2V8h-2V6h2V4h2v2h2v2h-2z" />
    </g>
  </Icon>
);
export { SvgConference as Conference };
